import { Error } from '@mui/icons-material'

import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'

import { ModalHeader } from '@/components/Modal'

import { useController } from '../hooks/useController'
import { useShowOutOfStorageSpaceModal } from '../hooks/useShowOutOfStorageSpaceModal'
import { useTexts } from '../useTexts'

export function Header() {
  const { close } = useController()
  const { acknowledgeModal } = useShowOutOfStorageSpaceModal()
  const texts = useTexts()

  const onClose = () => {
    acknowledgeModal()
    close?.()
  }

  return (
    <ModalHeader
      actions={[<ActionBarItem icon={<Close />} key="close" onClick={onClose} label="" />]}
      title={texts.outOfStorageSpaceTitle}
      avatar={<Error color="error" fontSize="large" />}
    />
  )
}
